const ALL_CONST = {
  welcome: "Bienvenue sur le passe-partout Kaiju React de Viamagus !",
  message: "Bonjour!! C'est chez moi - VIEW-1 !",
  "label.view1.post_heading": "En-tête de poste",
  "label.view1.post_description": "Description du poste",
  "label.view2.user_name": "Enter Nom",
  "label.user_name": "Enter Nom",
  "message.success": "Enter Name",
  "validator.mandatory": "C'est un champ obligatoire",
  "component.button.save": "sauvegarder",
  "component.button.cancel": "Annuler",
};

export default ALL_CONST;
